import axios from 'axios';

/**
 * This class includes all the util functions used in the search feature.
 */
export default class SearchUtils {
    static pushGlobalSearchEvent = (event, properties = {}) => {
        properties.source = window.location.pathname;

        axios({
          method: 'get',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json'
          },
          url: wbConfig.baseUrl + '/search/pushGlobalSearchEvent',
          params: { event, properties }
        });
    }
}